/* eslint-disable no-console */
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

import { ThreeDots } from "react-loader-spinner";
import useAppTranslations from "../hooks/useAppTranslations";
import LandingWithoutForm from "../components/LandingWithoutForm";

import Translate from "../components/Translate";
import api from "../services/api";

export default function ConfirmationEmail() {
  const { t } = useAppTranslations();
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const { email } = location.state;

  const resendEmail = async () => {
    setLoading(true);
    await api.postResendEmail(email, "recover-password");
    setLoading(false);
  };

  return (
    <LandingWithoutForm
      headerTitle={t("confirmation:title")}
      CardBodyContent={
        <Box
          className="rounded-2xl flex flex-col"
          sx={theme => ({
            py: 4,
            px: 4,
            background: theme.palette.background.default,
            border: `solid 1px ${theme.palette.grey[300]}`,

            [theme.breakpoints.down("sm")]: {
              border: "none",
              py: 1.5,
              px: 2
            }
          })}
        >
          <Box className="grow">
            <Typography variant="h2" fontSize={28} className="pb-8">
              <Translate src="confirmation:subtitle" />
            </Typography>
            <Typography variant="body2" className="pb-8">
              <Translate src="confirmation:desc" />
            </Typography>
            <Button
              type="button"
              sx={{ marginTop: 4, py: 1.5 }}
              variant="contained"
              color="primary"
              fullWidth
              onClick={resendEmail}
            >
              {loading ? (
                <Typography className="flex flex-row items-center" variant="button">
                  <p className="pr-2">Reenviando</p>
                  <ThreeDots
                    height="30"
                    width="30"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible
                  />
                </Typography>
              ) : (
                <Typography variant="button">{t("success:button_title")}</Typography>
              )}
            </Button>
          </Box>
        </Box>
      }
    />
  );
}
